import Column from '@components/Column';
import Row from '@components/Row';
import Skeleton from '@components/Skeleton';
import styled from '@emotion/styled';

interface Props {
    count?: number;
}

function EasyCardSkeletons({ count = 3 }: Props) {
    return (
        <Column fullWidth aria-busy>
            {Array.from({ length: count }).map((_, idx) => (
                <Item key={`easy-card-sk-${idx}`} fullWidth spacing={12}>
                    <Skeleton width={90} height={60} shape='block' />
                    <Contents fullWidth spacing={4}>
                        <Skeleton width='60%' height={22} />
                        <Skeleton width='30%' height={22} />
                    </Contents>
                </Item>
            ))}
        </Column>
    );
}

const Item = styled(Row)`
    padding: 16px;
`;

const Contents = styled(Column)`
    flex: 1;
`;

export default EasyCardSkeletons;
